import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConditionalApproval = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "conditionalApproval",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17698",
		"data-name": "Group 17698",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13078",
				"data-name": "Path 13078",
				d: "M8,4,9.3,2.375A1,1,0,0,1,10.081,2H13.92a1,1,0,0,1,.781.375L16,4h0V5a1,1,0,0,1-1,1H9A1,1,0,0,1,8,5V4Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13079",
				"data-name": "Path 13079",
				d: "M9.667,9.333,8,11,7,10",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13080",
				"data-name": "Path 13080",
				d: "M13,18h3",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_17699",
				"data-name": "Group 17699",
				transform: "translate(0.333 -3.939)",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_13086",
					"data-name": "Path 13086",
					d: "M13,18h3",
					transform: "translate(10.475 -4.981) rotate(45)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_13087",
					"data-name": "Path 13087",
					d: "M0,0H3",
					transform: "translate(9.061 16.939) rotate(135)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13081",
				"data-name": "Path 13081",
				d: "M13,10h3",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13082",
				"data-name": "Path 13082",
				d: "M9.667,13.333,8,15,7,14",
				transform: "translate(0 4)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13083",
				"data-name": "Path 13083",
				d: "M13,14h3",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13084",
				"data-name": "Path 13084",
				d: "M16,4h2a2,2,0,0,1,2,2V20a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H8",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_13085",
		"data-name": "Path 13085",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgConditionalApproval;
